/**
 * 供 axios / EventSource 使用的「站点根」base，不应包含 `/api`。
 * 业务请求路径统一写成 `/api/...`；若此处再带 `/api`，会拼成 `/api/api/...`。
 *
 * 兼容历史：VITE_API_URL 写成 `https://域名/api` 时自动去掉末尾 `/api`。
 */
export function resolvePublicApiBaseUrl(): string {
  const raw = import.meta.env.VITE_API_URL as string | undefined;
  if (raw != null && String(raw).trim() !== '') {
    let s = String(raw).trim().replace(/\/+$/, '');
    if (s.endsWith('/api')) {
      s = s.slice(0, -4).replace(/\/+$/, '');
    }
    if (s === '/api' || s === '') {
      return '';
    }
    return s;
  }
  return import.meta.env.PROD ? '' : '';
}
